// removed by extract-text-webpack-plugin
module.exports = {"addClientForm":"_2RXt3857Y2yKf6bcb_1PiM","formFieldText":"_2oaroOMDdydFkZCjQPd1cX","addClientButton":"_3n_1mVgAFWO_LpnSAfVByZ","cancelClientButton":"OWAHyz1mGqD7YNK2qggxG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/AddClientForm.css
// module id = 715
// module chunks = 0